import React, { useState } from 'react';
import {
    Container, Form, Button, Row, Col, Card, Alert, Dropdown
} from 'react-bootstrap';
import {
    Checkbox,
    FormControlLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    FormGroup,
    Box,
} from "@mui/material";
import DatePicker from 'react-datepicker';
import TimePicker from 'react-time-picker';
import Select from "react-select";
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faSnapchat, faWhatsapp, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faLocationDot, faPhone, } from '@fortawesome/free-solid-svg-icons';

function BookingForm() {
    const [clientName, setClientName] = useState('');
    const [bride, setBride] = useState('');
    const [serviceType, setServiceType] = useState([]);
    const [assignedStaff, setAssignedStaff] = useState([]);
    const [adults, setAdults] = useState('');
    const [children, setChildren] = useState('');
    const [time, setTime] = useState("12:00");
    const placeholderText = 'اختر الوقت المطلوب'; // The placeholder text you want to show initially
    const [isChecked, setIsChecked] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const [eventDate, setEventDate] = useState('');
    const [partyLocation, setPartyLocation] = useState('');
    const [hotelName, setHotelName] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('');
    const [selectedPiece, setSelectedPiece] = useState('');
    const [streetNumber, setStreetNumber] = useState('');
    const [avenueNumber, setAvenueNumber] = useState('');
    const [houseNumber, setHouseNumber] = useState('');
    const [vipRoom, setVipRoom] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [mapLink, setMapLink] = useState('');
    const [additionalPhoneNumber, setAdditionalPhoneNumber] = useState('');
    const [notes, setNotes] = useState('');
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertVariant, setAlertVariant] = useState('success');
    const [language, setLanguage] = useState('ar');

    const pieces = [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
        { label: "13", value: "13" },
        { label: "14", value: "14" },
        { label: "15", value: "15" },
        { label: "16", value: "16" },
        { label: "17", value: "17" },
        { label: "18", value: "18" },
        { label: "19", value: "19" },
        { label: "أخرى", value: "أخرى" }
    ];

    const handlePieceChange = (e) => {
        setSelectedPiece(e.target.value);
    };

    const locations = [
        { label: "مدينة الكويت", value: "مدينة الكويت" },
        { label: "دسمان", value: "دسمان" },
        { label: "الشرق", value: "الشرق" },
        { label: "الصوابر", value: "الصوابر" },
        { label: "المرقاب", value: "المرقاب" },
        { label: "القبلة", value: "القبلة" },
        { label: "الصالحية", value: "الصالحية" },
        { label: "الوطية", value: "الوطية" },
        { label: "بنيد القار", value: "بنيد القار" },
        { label: "كيفان", value: "كيفان" },
        { label: "الدوحة", value: "الدوحة" },
        { label: "الدسمة", value: "الدسمة" },
        { label: "الدعية", value: "الدعية" },
        { label: "المنصورية", value: "المنصورية" },
        { label: "ضاحية عبد الله السالم", value: "ضاحية عبد الله السالم" },
        { label: "النزهة", value: "النزهة" },
        { label: "الفيحاء", value: "الفيحاء" },
        { label: "الشامية", value: "الشامية" },
        { label: "الروضة", value: "الروضة" },
        { label: "العديلية", value: "العديلية" },
        { label: "الخالدية", value: "الخالدية" },
        { label: "القادسية", value: "القادسية" },
        { label: "قرطبة", value: "قرطبة" },
        { label: "السرة", value: "السرة" },
        { label: "اليرموك", value: "اليرموك" },
        { label: "الشويخ", value: "الشويخ" },
        { label: "الري", value: "الري" },
        { label: "غرناطة", value: "غرناطة" },
        { label: "الصليبيخات والدوحة", value: "الصليبيخات والدوحة" },
        { label: "النهضة", value: "النهضة" },
        { label: "مدينة جابر الأحمد", value: "مدينة جابر الأحمد" },
        { label: "القيروان", value: "القيروان" },
        { label: "شمال غرب الصليبيخات", value: "شمال غرب الصليبيخات" },
        { label: "الفنطاس", value: "الفنطاس" },
        { label: "العقيلة", value: "العقيلة" },
        { label: "الظهر", value: "الظهر" },
        { label: "المقوع", value: "المقوع" },
        { label: "المهبولة", value: "المهبولة" },
        { label: "الرقة", value: "الرقة" },
        { label: "هدية", value: "هدية" },
        { label: "أبو حليفة", value: "أبو حليفة" },
        { label: "الصباحية", value: "الصباحية" },
        { label: "المنقف", value: "المنقف" },
        { label: "الفحيحيل", value: "الفحيحيل" },
        { label: "الأحمدي", value: "الأحمدي" },
        { label: "الوفرة", value: "الوفرة" },
        { label: "الزور", value: "الزور" },
        { label: "الخيران", value: "الخيران" },
        { label: "ميناء عبد الله", value: "ميناء عبد الله" },
        { label: "الوفرة الزراعية", value: "الوفرة الزراعية" },
        { label: "بنيدر", value: "بنيدر" },
        { label: "الجليعة", value: "الجليعة" },
        { label: "الرابية", value: "الرابية" },
        { label: "الرحاب", value: "الرحاب" },
        { label: "الرقعي", value: "الرقعي" },
        { label: "الري الصناعية", value: "الري الصناعية" },
        { label: "ضاحية صباح الناصر", value: "ضاحية صباح الناصر" },
        { label: "ضاحية عبد الله المبارك", value: "ضاحية عبد الله المبارك" },
        { label: "ضاحية غرب عبد الله المبارك", value: "ضاحية غرب عبد الله المبارك" },
        { label: "الضجيج", value: "الضجيج" },
        { label: "العارضية", value: "العارضية" },
        { label: "العارضية الصناعية", value: "العارضية الصناعية" },
        { label: "العباسية", value: "العباسية" },
        { label: "الفردوس", value: "الفردوس" },
        { label: "الفروانية", value: "الفروانية" },
        { label: "الحساوي", value: "الحساوي" },
        { label: "الشدادية", value: "الشدادية" },
        { label: "أبرق خيطان", value: "أبرق خيطان" },
        { label: "الأندلس", value: "الأندلس" },
        { label: "اشبيلية", value: "اشبيلية" },
        { label: "جليب الشيوخ", value: "جليب الشيوخ" },
        { label: "خيطان", value: "خيطان" },
        { label: "خيطان الجديدة", value: "خيطان الجديدة" },
        { label: "العمرية", value: "العمرية" },
        { label: "الصليبية", value: "الصليبية" },
        { label: "أمغرة", value: "أمغرة" },
        { label: "النعيم", value: "النعيم" },
        { label: "القصر", value: "القصر" },
        { label: "الواحة", value: "الواحة" },
        { label: "تيماء", value: "تيماء" },
        { label: "النسيم", value: "النسيم" },
        { label: "العيون", value: "العيون" },
        { label: "القيصرية", value: "القيصرية" },
        { label: "العبدلي", value: "العبدلي" },
        { label: "الجهراء القديمة", value: "الجهراء القديمة" },
        { label: "الجهراء الجديدة", value: "الجهراء الجديدة" },
        { label: "كاظمة", value: "كاظمة" },
        { label: "مدينة سعد العبد الله", value: "مدينة سعد العبد الله" },
        { label: "السالمي", value: "السالمي" },
        { label: "المطلاع", value: "المطلاع" },
        { label: "مدينة الحرير", value: "مدينة الحرير" },
        { label: "كبد", value: "كبد" },
        { label: "الروضتين", value: "الروضتين" },
        { label: "الصبية", value: "الصبية" },
        { label: "حولي", value: "حولي" },
        { label: "الشعب", value: "الشعب" },
        { label: "السالمية", value: "السالمية" },
        { label: "الرميثية", value: "الرميثية" },
        { label: "الجابرية", value: "الجابرية" },
        { label: "مشرف", value: "مشرف" },
        { label: "جنوب السرة", value: "جنوب السرة" },
        { label: "الزهراء", value: "الزهراء" },
        { label: "الصديق", value: "الصديق" },
        { label: "حطين", value: "حطين" },
        { label: "السلام", value: "السلام" },
        { label: "الشهداء", value: "الشهداء" },
        { label: "بيان", value: "بيان" },
        { label: "آلبدع", value: "آلبدع" },
        { label: "النقرة", value: "النقرة" },
        { label: "ميدان حولي", value: "ميدان حولي" },
        { label: "ضاحية مبارك العبد الله الجابر", value: "ضاحية مبارك العبد الله الجابر" },
        { label: "سلوى", value: "سلوى" },
        { label: "العدان", value: "العدان" },
        { label: "القرين", value: "القرين" },
        { label: "ضاحية صباح السالم", value: "ضاحية صباح السالم" },
        { label: "القصور", value: "القصور" },
        { label: "المطبة", value: "المطبة" },
        { label: "الروضة الصناعية", value: "الروضة الصناعية" },
        { label: "الزهراء الصناعية", value: "الزهراء الصناعية" },
        { label: "أبو فطيرة", value: "أبو فطيرة" },
        { label: "أبو الحصانية", value: "أبو الحصانية" },
        { label: "الشعيبة", value: "الشعيبة" },
        { label: "الضباعية", value: "الضباعية" },
        { label: "الفنيطيس", value: "الفنيطيس" },
        { label: "المسايل", value: "المسايل" },
        { label: "المسيلة", value: "المسيلة" },
        { label: "النويصيب", value: "النويصيب" },
        { label: "صبحان", value: "صبحان" },
        { label: "ضاحية جابر العلي", value: "ضاحية جابر العلي" },
        { label: "ضاحية علي صباح السالم أم الهيمان", value: "ضاحية علي صباح السالم أم الهيمان" },
        { label: "ضاحية فهد الأحمد", value: "ضاحية فهد الأحمد" },
        { label: "ضاحية مبارك الكبير", value: "ضاحية مبارك الكبير" },
        { label: "مدينة الخيران", value: "مدينة الخيران" },
        { label: "مدينة صباح الأحمد", value: "مدينة صباح الأحمد" },
        { label: "مدينة صباح الأحمد البحرية", value: "مدينة صباح الأحمد البحرية" },
        { label: "واره", value: "واره" }
    ];


    const handleSubmit = async (e) => {
        e.preventDefault();

        const bookingData = {
            clientName,
            bride,
            serviceType,
            assignedStaff,
            adults,
            children,
            time,
            eventDate,
            partyLocation,
            hotelName,
            selectedLocation,
            selectedPiece,
            streetNumber,
            avenueNumber,
            houseNumber,
            vipRoom,
            phoneNumber,
            mapLink,
            additionalPhoneNumber,
            notes,
            language
        };

        try {
            const response = await fetch('https://peacesalonkw.com/api/bookings', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(bookingData),
            });

            const result = await response.json();

            if (response.ok) {
                setAlertMessage('تم حجز موعدك بنجاح.');
                setAlertVariant('success');
                clearForm();
            } else {
                setAlertMessage('يجب ملء جميع الحقول المطلوبة');
                setAlertVariant('danger');
            }
        } catch (error) {
            setAlertMessage('يجب ملء جميع الحقول المطلوبة');
            setAlertVariant('danger');
        }
    };

    // Function to clear form
    const clearForm = () => {
        setClientName('');
        setBride('');
        setServiceType([]);
        setAssignedStaff([]);
        setAdults('');
        setChildren('');
        setTime('');
        setEventDate('');
        setPartyLocation('');
        setHotelName('');
        setSelectedLocation('');
        setSelectedPiece('');
        setStreetNumber('');
        setAvenueNumber('');
        setHouseNumber('');
        setVipRoom('');
        setPhoneNumber('');
        setMapLink('');
        setAdditionalPhoneNumber('');
        setNotes('');
        setLanguage('ar');
    };

    const handleLocationChange = (selected) => {
        setSelectedLocation(selected);
    };

    const handleServiceTypeChange = (selectedOptions) => {
        setServiceType(selectedOptions);
    };

    const handleAssignedStaffChange = (selectedOptions) => {
        setAssignedStaff(selectedOptions);
    };

    // Prepare options for react-select
    const serviceTypeOptions = [
        // Makeup Options
        { value: 'brideMakeup', label: language === 'en' ? 'Makeup (Bride)' : 'ميك أب (عروس)' },
        { value: 'receptionMakeup', label: language === 'en' ? 'Makeup (Reception)' : 'ميك اب (استقبال)' },
        { value: 'engagementMakeup', label: language === 'en' ? 'Makeup (Engagement)' : 'ميك اب (خطبه)' },
        { value: 'milgaMakeup', label: language === 'en' ? 'Makeup (Milga)' : 'ميك اب (ملجه)' },
        { value: 'yellowMakeup', label: language === 'en' ? 'Makeup (Yellow)' : 'ميك اب (يلوه)' },
        { value: 'eveningMakeup', label: language === 'en' ? 'Makeup (Evening)' : 'ميك اب (مسائيه)' },
        { value: 'partyMakeup', label: language === 'en' ? 'Makeup (Party)' : 'ميك أب (سهره)' },

        // Hairstyle Options
        { value: 'brideHairstyle', label: language === 'en' ? 'Hairstyle (Bride)' : 'تسريحه (عروس)' },
        { value: 'receptionHairstyle', label: language === 'en' ? 'Hairstyle (Reception)' : 'تسريحه (استقبال)' },
        { value: 'milgaHairstyle', label: language === 'en' ? 'Hairstyle (Milga)' : 'تسريحه (ملجه)' },
        { value: 'engagementHairstyle', label: language === 'en' ? 'Hairstyle (Engagement)' : 'تسريحه (خطبه)' },
        { value: 'yellowHairstyle', label: language === 'en' ? 'Hairstyle (Yellow)' : 'تسريحه (يلوه)' },
        { value: 'partyHairstyle', label: language === 'en' ? 'Hairstyle (Party)' : 'تسريحه (سهره)' },

        // Hair Treatments
        { value: 'extension', label: language === 'en' ? 'Extension' : 'تركيب اكستنشن' },
        { value: 'blowDry', label: language === 'en' ? 'Blow Dry' : 'سشوار' },
        { value: 'wavy', label: language === 'en' ? 'Wavy' : 'ويفي' },
        { value: 'hairRegrowth', label: language === 'en' ? 'Hair Treatment (Regrowth)' : 'علاجات شعر (انبات)' },
        { value: 'hairFallTreatment', label: language === 'en' ? 'Hair Treatment (Anti-hair fall)' : 'علاجات شعر (علاج التساقط)' },
        { value: 'olaplex', label: language === 'en' ? 'Olaplex Treatment' : 'علاجات شعر (اولابلكس)' },
        { value: 'agonMask', label: language === 'en' ? 'Agon Mask Treatment' : 'علاجات شعر(اجون ماسك)' },
        { value: 'tia', label: language === 'en' ? 'Tia Treatment' : 'علاجات شعر(تيا)' },
        { value: 'charcoalMask', label: language === 'en' ? 'Charcoal Mask' : 'علاجات شعر(ماسك الفحم)' },
        { value: 'caviarMask', label: language === 'en' ? 'Caviar Mask' : 'علاجات شعر(ماسك كافيار)' },
        { value: 'bbPlus', label: language === 'en' ? 'BB Plus Treatment' : 'علاجات شعر(+bb)' },
        { value: 'amazon', label: language === 'en' ? 'Amazon Treatment' : 'علاجات شعر(امازون)' },
        { value: 'omega3', label: language === 'en' ? 'Omega 3 Treatment' : 'علاجات شعر(اوميجا 3)' },
        { value: 'protein', label: language === 'en' ? 'Protein Treatment' : 'علاجات شعر(بروتين)' },
        { value: 'filler', label: language === 'en' ? 'Hair Filler Treatment' : 'علاجات شعر(فلر)' },

        // Skin and Beauty Services
        { value: 'skinTreatment', label: language === 'en' ? 'Skin Cleaning' : 'تنظيف بشره' },
        { value: 'lashExtensions', label: language === 'en' ? 'Lash Extensions' : 'تركيب رموش' },
        { value: 'turkishStyle', label: language === 'en' ? 'Turkish Style' : 'تركش ستايل' },
        { value: 'lashLift', label: language === 'en' ? 'Lash Lift' : 'رفع الرموش' },
        { value: 'browCleaning', label: language === 'en' ? 'Brow Cleaning' : 'تنظيف الحواجب' },
        { value: 'semiPermanentMakeup', label: language === 'en' ? 'Semi-Permanent Makeup (Microblading)' : 'المكياج شبه الدائم (المايكروبليدنج)' },
        { value: 'faceShaving', label: language === 'en' ? 'Full Face Shaving' : 'حف وجه كامل' },
        { value: 'waxing', label: language === 'en' ? 'Waxing' : 'شمع' },
        { value: 'moroccanBath', label: language === 'en' ? 'Moroccan Bath' : 'حمام مغربي' },
        { value: 'turkishBath', label: language === 'en' ? 'Turkish Bath' : 'حمام تركي' },

        // Massage Options
        { value: 'fullBodyMassage', label: language === 'en' ? 'Full Body Massage' : 'مساج (فل بودي)' },
        { value: 'footMassage', label: language === 'en' ? 'Foot Massage' : 'مساج (القدمين)' },
        { value: 'hotStoneMassage', label: language === 'en' ? 'Hot Stone Massage' : 'مساج (حجرحراري)' },
        { value: 'neckMassage', label: language === 'en' ? 'Neck Massage' : 'مساج (العنق)' },
        { value: 'headMassage', label: language === 'en' ? 'Head Massage' : 'مساج (الرأس)' },
        { value: 'relaxationMassage', label: language === 'en' ? 'Relaxation Massage' : 'مساج (ريلكسيشن)' },

        // Nail and Foot Care Options
        { value: 'pedicure', label: language === 'en' ? 'Pedicure' : 'بديكير' },
        { value: 'manicure', label: language === 'en' ? 'Manicure' : 'مانيكير' },
        { value: 'footlogix', label: language === 'en' ? 'Footlogix' : 'فوت لوجكس' },
        { value: 'handGloves', label: language === 'en' ? 'Hand Gloves' : 'قفازات اليد' },
        { value: 'footGloves', label: language === 'en' ? 'Foot Gloves' : 'قفازات القدم' },
        { value: 'acrylic', label: language === 'en' ? 'Acrylic' : 'اكريليك' },
        { value: 'frenchAcrylic', label: language === 'en' ? 'French Acrylic' : 'اكريليك فرنسي' },
        { value: 'polygel', label: language === 'en' ? 'Poly Gel' : 'بولي جل' },
        { value: 'gelPolish', label: language === 'en' ? 'Gel Polish' : 'طلاء الجلش' },
        { value: 'nailPolish', label: language === 'en' ? 'Nail Polish' : 'طلاء الاضافر' },
        { value: 'ombrePolish', label: language === 'en' ? 'Ombre Polish' : 'طلاء الاومبري' },
    ];

    const assignedStaffOptions = [
        { value: 'mariamKazem', label: language === 'en' ? 'Makeup Artist & Hairstylist Mariam Kazem' : 'الميكب ارتست والهيرستايل مريم كاظم' },
        { value: 'deema', label: language === 'en' ? 'Makeup Artist Deema' : 'الميكب ارتست ديمة' },
        { value: 'alam', label: language === 'en' ? 'Hairstylist Alam' : 'الهيرستايل عالم' },
        { value: 'khadija', label: language === 'en' ? 'Hairstylist Khadija' : 'الهيرستايل خديجه' },
        { value: 'farah', label: language === 'en' ? 'Hairstylist Farah' : 'الهيرستايل فرح' },
        { value: 'fawzia', label: language === 'en' ? 'Assistant Fawzia' : 'المساعدة فوزيه' },
        { value: 'debal', label: language === 'en' ? 'Assistant Debal' : 'المساعدة ديبال' },
    ];

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const handleDialogOpen = () => {
        setIsDialogOpen(true);
    };

    const handleDialogClose = () => {
        setIsDialogOpen(false);
    };


    const filteredServiceTypeOptions = serviceTypeOptions.filter(
        (option) => !serviceType.some((selected) => selected.value === option.value)
    );

    const filteredAssignedStaffOptions = assignedStaffOptions.filter(
        (option) => !assignedStaff.some((selected) => selected.value === option.value)
    );

    return (
        <Container dir={language === 'ar' ? 'rtl' : 'ltr'} className="mt-5">
            <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', marginBottom: '20px' }}>
                <img className="logo-white" alt="Logo white" src={require("./assets/logo-white.png")} style={{ height: '180px' }} />
            </div>
            <Card className="p-4 shadow-lg border-0 mb-4" style={{ borderRadius: '15px', backgroundColor: '#edbf6f' }}>
                <h2 className="text-center" style={{ color: '#3b3b3b', fontWeight: 'bold' }}>
                    {language === 'en' ? 'Booking Form' : 'نموذج الحجز'}
                </h2>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="clientName">
                        <Form.Control
                            type="text"
                            value={clientName}
                            onChange={(e) => setClientName(e.target.value)}
                            placeholder={'ادخل اسم الثنائى (اسم العميل)'}
                        />
                    </Form.Group>
                    <div style={{ height: '10px' }} />
                    <Form.Group controlId="bride">
                        <Form.Control
                            as="select"
                            value={bride}
                            onChange={(e) => setBride(e.target.value)}
                        >
                            <option value="" disabled>{'هل انتي عروس ؟'}</option>
                            <option value="yes">{language === 'en' ? 'Yes' : 'نعم'}</option>
                            <option value="no">{language === 'en' ? 'No' : 'لا'}</option>
                        </Form.Control>
                    </Form.Group>
                    <div style={{ height: '10px' }} />
                    <Row className="mb-4">
                        <Col xs={12} sm={12}>
                            <Form.Group controlId="serviceType">
                                <Select
                                    isMulti
                                    options={filteredServiceTypeOptions}
                                    value={serviceType}
                                    onChange={handleServiceTypeChange}
                                    placeholder={language === 'en' ? 'Select Service Type' : 'اختر نوع الخدمة'}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col xs={12} sm={12}>
                            <Form.Group controlId="assignedStaff">
                                <Select
                                    isMulti
                                    options={filteredAssignedStaffOptions}
                                    value={assignedStaff}
                                    onChange={handleAssignedStaffChange}
                                    placeholder={language === 'en' ? 'Select Staff' : 'اختر الموظف المختص'}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col xs={12} sm={12}>
                            <Form.Group controlId="adults">
                                <Form.Control as="select" value={adults} onChange={(e) => setAdults(e.target.value)}>
                                    <option value="" disabled>{'اختر عدد المرافقات (الكبار)'}</option>
                                    <option value='لا يوجد'>{language === 'en' ? 'None' : 'لا يوجد'}</option>
                                    {[...Array(20).keys()].map((num) => (
                                        <option key={num + 1} value={num + 1}>{num + 1}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col xs={12} sm={12}>
                            <Form.Group controlId="children">
                                <Form.Control as="select" value={children} onChange={(e) => setChildren(e.target.value)}>
                                    <option value="" disabled>{'اختر عدد المرافقات (اطفال)'}</option>
                                    <option value='لا يوجد'>{language === 'en' ? 'None' : 'لا يوجد'}</option>
                                    {[...Array(20).keys()].map((num) => (
                                        <option key={num + 1} value={num + 1}>{num + 1}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Col xs={6} sm={6}>
                            <Form.Group controlId="preferredTime">
                                <Form.Control
                                    type="time"
                                    value={time || ''}
                                    onChange={(e) => setTime(e.target.value)}
                                    placeholder="اختر الوقت المطلوب"
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={6} sm={6}>
                            <Form.Group controlId="eventDate">
                                <DatePicker
                                    selected={eventDate}
                                    onChange={(date) => setEventDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    placeholderText={'اختر تاريخ الحفلة '}
                                    minDate={new Date()} // Ensures the date can't be in the past
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Col xs={6} sm={6}>
                            <Form.Group controlId="partyLocation">
                                <Form.Control
                                    as="select"
                                    value={partyLocation}
                                    onChange={(e) => setPartyLocation(e.target.value)}
                                >
                                    <option value="" disabled>{'اختر مكان الحفلة'}</option>
                                    <option value="hotel">{language === 'en' ? 'Hotel' : 'فندق'}</option>
                                    <option value="house">{language === 'en' ? 'House' : 'بيت'}</option>
                                    <option value="weddingHall">{language === 'en' ? 'Wedding Hall' : 'صالة الافراح'}</option>
                                    <option value="hall">{language === 'en' ? 'Hall' : 'قاعة'}</option>
                                    <option value="lounge">{language === 'en' ? 'Lounge' : 'لاونش'}</option>
                                    <option value="chalet">{language === 'en' ? 'Chalet' : 'شاليه'}</option>
                                    <option value="farm">{language === 'en' ? 'Farm' : 'مزرعة'}</option>
                                    <option value="makeupSalon">{language === 'en' ? 'Makeup Artist Salon' : 'صالون ميكب ارتست'}</option>
                                    <option value="beautyInstitute">{language === 'en' ? 'Beauty Institute and Salon' : 'معهد و صالون بيس'}</option>
                                    <option value="photoStudio">{language === 'en' ? 'Photography Studio' : 'ستوديو التصوير'}</option>
                                    <option value="restaurant">{language === 'en' ? 'Restaurant' : 'مطعم'}</option>
                                    <option value="gccCountries">{language === 'en' ? 'GCC Countries' : 'دول مجلس التعاون'}</option>
                                    <option value="toBeDecided">{language === 'en' ? 'To be decided later' : 'سوف يتم تحديده لاحقاً'}</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col xs={6} sm={6}>
                            <Form.Group controlId="hotelName">
                                <Form.Control as="select" value={hotelName} onChange={(e) => setHotelName(e.target.value)}>
                                    <option value="" disabled>{'اختر اسم الفندق'}</option>
                                    <option value="waldorfAstoria">{language === 'en' ? 'Waldorf Astoria' : 'والدروف ستوريا'}</option>
                                    <option value="fourSeasons">{language === 'en' ? 'Four Seasons' : 'فورسيزون'}</option>
                                    <option value="alRayya">{language === 'en' ? 'Al Rayya' : 'الرايه'}</option>
                                    <option value="symphony">{language === 'en' ? 'The Symphony' : 'السيمفوني'}</option>
                                    <option value="jumeirah">{language === 'en' ? 'Jumeirah' : 'الجميرا'}</option>
                                    <option value="crownPlaza">{language === 'en' ? 'Crowne Plaza' : 'كراون بلازا'}</option>
                                    <option value="grandHyattResidence">{language === 'en' ? 'Grand Hyatt Residence' : 'جراند حياة رزيدنس'}</option>
                                    <option value="grandHyatt360">{language === 'en' ? 'Grand Hyatt 360' : 'جراند حياة 360'}</option>
                                    <option value="millenniumSalmiya">{language === 'en' ? 'Millennium Salmiya' : 'ميلينيوم السالميه'}</option>
                                    <option value="millenniumCentral">{language === 'en' ? 'Millennium Central' : 'ميلينيوم سنترال'}</option>
                                    <option value="hyattRegencyAlKout">{language === 'en' ? 'Hyatt Regency Al Kout' : 'حياة ريجنسي الكوت'}</option>
                                    <option value="alKoutBeach">{language === 'en' ? 'Al Kout Beach' : 'شاطيء الكوت'}</option>
                                    <option value="hiltonResort">{language === 'en' ? 'Hilton Resort Al Mangaf' : 'منتجع هيلتون المنقف'}</option>
                                    <option value="regencyAlBidaa">{language === 'en' ? 'Regency Al Bidaa' : 'ريجنسي البدع'}</option>
                                    <option value="movenpickHawraa">{language === 'en' ? 'Movenpick Al Harraa' : 'موفمبيك الحره'}</option>
                                    <option value="movenpickBidaa">{language === 'en' ? 'Movenpick Al Bidaa' : 'موفمبيك البدع'}</option>
                                    <option value="radissonBlu">{language === 'en' ? 'Radisson Blu' : 'راديسون بلو'}</option>
                                    <option value="marina">{language === 'en' ? 'Marina' : 'مارينا'}</option>
                                    <option value="gardenHotel">{language === 'en' ? 'Garden Hotel' : 'جاردن هوتيل'}</option>
                                    <option value="arjaanBidaa">{language === 'en' ? 'Arjaan Al Bidaa' : 'ارجان البدع'}</option>
                                    <option value="alHamra">{language === 'en' ? 'Al Hamra' : 'الحمراء'}</option>
                                    <option value="safirFintas">{language === 'en' ? 'Safir Al Fintas' : 'سفير الفنطاس'}</option>
                                    <option value="stRegisSheraton">{language === 'en' ? 'St. Regis (Sheraton)' : 'سانت ريجس (الشيراتون)'}</option>
                                    <option value="holidayInnSalmiya">{language === 'en' ? 'Holiday Inn Salmiya' : 'هوليدي ان السالميه'}</option>
                                    <option value="holidayInnFarwaniya">{language === 'en' ? 'Holiday Inn Farwaniya' : 'هوليدي ان الفروانيه'}</option>
                                    <option value="copthorneJahra">{language === 'en' ? 'Copthorne Jahra (Slailey)' : 'كوبثرون الجهراء (سليل)'}</option>
                                    <option value="alNakheel">{language === 'en' ? 'Al Nakheel' : 'النخيل'}</option>
                                    <option value="yosifiHall">{language === 'en' ? 'Yousifi Hall' : 'قاعه اليوسفي'}</option>
                                    <option value="divanHall">{language === 'en' ? 'Divan Hall' : 'قاعه ديفان'}</option>
                                    <option value="boulevardHall">{language === 'en' ? 'Boulevard Hall' : 'قاعه بوليفارد'}</option>
                                    <option value="ajwanHallGrandHotel">{language === 'en' ? 'Ajwan Hall (Grand Hotel)' : 'قاعة اجوان (جراند هوتيل)'}</option>
                                    <option value="salwaSabahHall">{language === 'en' ? 'Salwa Sabah Hall' : 'قاعة سلوى الصباح'}</option>
                                    <option value="royalHall">{language === 'en' ? 'Royal Hall' : 'قاعة الملكيه'}</option>
                                    <option value="regencyAlKout">{language === 'en' ? 'Regency Al Kout' : 'ريجنسي الكوت'}</option>
                                    <option value="ramada">{language === 'en' ? 'Ramada' : 'رمادا'}</option>
                                    <option value="other">{language === 'en' ? 'Other' : 'أخرى'}</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Col xs={12} sm={12}>
                            <div className="form-group" controlId="locationSelect">
                                <Select
                                    value={selectedLocation}
                                    onChange={handleLocationChange}
                                    options={locations}
                                    getOptionLabel={(e) => e.label}  // Option label display
                                    getOptionValue={(e) => e.value}  // Option value selection
                                    placeholder="اختر المحافظة والمدينة"
                                    isClearable={true} // Option to clear selection
                                    isSearchable={true} // Enable search
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col xs={6} sm={6}>
                            <Form.Group controlId="pieceSelect">
                                <Form.Control
                                    as="select"
                                    value={selectedPiece}
                                    onChange={handlePieceChange}
                                >
                                    <option value="" disabled>{'اختر القطعة'}</option>
                                    {pieces.map((piece) => (
                                        <option key={piece.value} value={piece.value}>
                                            {piece.label}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col xs={6} sm={6}>
                            <Form.Group controlId="streetNumberInput">
                                <Form.Control
                                    type="text"
                                    value={streetNumber}
                                    onChange={(e) => setStreetNumber(e.target.value)}
                                    placeholder='ادخل رقم الشارع '
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-4">


                        <Col xs={6} sm={6}>
                            <Form.Group controlId="avenueNumberInput">
                                <Form.Control
                                    type="text"
                                    value={avenueNumber}
                                    onChange={(e) => setAvenueNumber(e.target.value)}
                                    placeholder='ادخل رقم جادة'
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={6} sm={6}>
                            <Form.Group controlId="streetNumberInput">
                                <Form.Control
                                    type="text"
                                    value={houseNumber}
                                    onChange={(e) => setHouseNumber(e.target.value)}
                                    placeholder='ادخل رقم المنزل'
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col xs={12} sm={12}>
                            <Form.Group controlId="vipRoom">
                                <Form.Control
                                    as="select"
                                    value={vipRoom}
                                    onChange={(e) => setVipRoom(e.target.value)}
                                >
                                    <option value="" disabled>{'هل تريد حجز غرفة VIP؟'}</option>
                                    <option value="yes">نعم</option>
                                    <option value="no">لا ارغب</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col xs={12} sm={12}>
                            <Form.Group controlId="mapLinkInput">
                                <Form.Control
                                    type="text"
                                    value={mapLink}
                                    onChange={(e) => setMapLink(e.target.value)}
                                    placeholder={'لصق هنا خريطة عنوان الحفلة'}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col xs={12} sm={12}>
                            <Form.Group controlId="phoneNumberInput">
                                <Form.Control
                                    type="text"
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                    placeholder={'ادخل رقم الموبايل '}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col xs={12} sm={12}>
                            <Form.Group controlId="additionalPhoneNumberInput">
                                <Form.Control
                                    type="text"
                                    value={additionalPhoneNumber}
                                    onChange={(e) => setAdditionalPhoneNumber(e.target.value)}
                                    placeholder={'ادخل رقم موبايل إضافي للضرورة'}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col sm={12}>
                            <Form.Group controlId="notesInput">
                                <Form.Control
                                    as="textarea"
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    placeholder={'ادخل الملاحظات'}
                                    rows={3}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {/* Alert message */}
                    {alertMessage && (
                        <Alert variant={alertVariant} onClose={() => setAlertMessage('')} dismissible>
                            {alertMessage}
                        </Alert>
                    )}
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                    color="primary"
                                />
                            }
                            label={
                                <Typography
                                    component="span"
                                    sx={{ textDecoration: "underline", cursor: "pointer" }}
                                    onClick={handleDialogOpen}
                                >
                                    أوافق على الشروط و الأحكام
                                </Typography>
                            }
                        />
                    </FormGroup>
                    <div style={{ height: '10px', width: '10px' }} />
                    <Button disabled={!isChecked} variant="primary" className="w-100 py-3" type="submit">
                        {'حجز'}
                    </Button>

                    {/* Dialog for Terms and Conditions */}
                    <Dialog
                        open={isDialogOpen}
                        onClose={handleDialogClose}
                        maxWidth="sm"
                        style={{ direction: "rtl", textAlign: "right" }}
                    >
                        <DialogTitle>الشروط و الأحكام</DialogTitle>
                        <DialogContent dividers>
                            <Typography variant="h6" gutterBottom>شروط تاكيد الحجز</Typography>
                            <Typography>
                                يتم تاكيد الحجز بعد دفع مبلغ العربون فقط.
                            </Typography>
                            <Typography variant="h6" gutterBottom>شروط الالغاء</Typography>
                            <Typography>
                                ١- لم يرد و لم يستبدل العربون فى حالة الغاء النهائي لأي سبب كان
                                (حالة وفاة - طلاق - الخ).
                                <br />
                                ٢- في حالة الغاء الحجز في يوم الموعد او نقص احد من المجموعة يعتبر
                                الحجز ملغيا من ذات نفسه بدون اي ابلاغ.
                            </Typography>
                            <Typography variant="h6" gutterBottom>شروط التاجيل</Typography>
                            <Typography>
                                ١- يتأجل تاريخ الحجز لمدة 3 أشهر من بعد تاريخ الحجز الأولى (في
                                حالة ابلاغنا 15 يوم قبل التاريخ فقط).
                                <br />
                                ٢- في حالة تأجيل الحجز لن يتغير و لن يستبدل الخدمة بخدمات أخرى.
                                <br />
                                ٣- يتأجل الحجز إلى التاريخ الجديد فقط لنفس العدد والخدمة
                                المتفق عليه في الحجز الأولى (في حالة توفير الوقت والمكان).
                            </Typography>
                            <Typography variant="h6" gutterBottom>شروط التأخير</Typography>
                            <Typography>
                                يتم تنظيم جدول المواعيد حسب الوقت المقرر والمنطقة قبل موعد الحجز
                                بأسبوع. في حالة تأخير عن التوقيت المتفق عليه أكثر من نصف ساعة يتم
                                ترحيل الموعد إلى آخر موعد.
                            </Typography>
                            <Typography variant="h6" gutterBottom>شروط تغير مكان الحفلة</Typography>
                            <Typography>
                                ١- في حالة تغير مكان الحجز إلى الأماكن التالية: الجهراء - الفحيحيل -
                                صباح الأحمد - أم الهيمان. سوف يتحمل العميل مبلغ ٥٠ دينار كرسوم تنقل.
                                <br />
                                ٢- على العميل ضرورة إبلاغنا فوراً في حالة تغير مكان الحفلة قبل
                                المناسبة بأسبوع لإعادة تنظيم جدول المواعيد حسب التوقيت والمنطقة.
                            </Typography>
                            <Typography variant="h6" gutterBottom>مبلغ العربون</Typography>
                            <Typography>
                                شعر وميكب العروس (١٥٠ دينار). شعر العروس تسريحتين (يلو - تسريحة
                                كاملة) (١٠٠ دينار). شعر العروس (٧٠ دينار). ميكب العروس (١٠٠ دينار).
                                ميكب السهرة (٢٠ دينار لكل شخص). شعر وميكب السهرة (٣٥ لكل شخص). تسريحة
                                المرافقات (١٥ دينار لكل شخص). تسريحة للأطفال (١٠ دينار لكل شخص).
                                <br />
                                * في حالة إلغاء الحجز لن يترحل مبلغ العربون لأشخاص آخرين أو استبداله
                                مع أي من خدمات أخرى بالصالون.
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDialogClose} variant="contained" color="primary">
                                إغلاق
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Form>
                <div className="d-flex justify-content-between align-items-center mt-4 p-3 border-top">
                    {/* Instagram Dropdown */}
                    <Dropdown>
                        <Dropdown.Toggle variant="link" id="dropdown-instagram" className="icon-link">
                            <FontAwesomeIcon icon={faInstagram} size='30px' />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                href="https://www.instagram.com/peacesalonkw"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ١- معهد و صالون بيس
                            </Dropdown.Item>
                            <Dropdown.Item
                                href="https://www.instagram.com/mariam_kazem11"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ٢-  الأرتست مريم كاظم
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {/* Snapchat Dropdown */}
                    <Dropdown>
                        <Dropdown.Toggle variant="link" id="dropdown-snapchat" className="icon-link">
                            <FontAwesomeIcon icon={faSnapchat} size='30px' />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                href="https://snapchat.com/t/9VuBjxDH"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ١- معهد و صالون بيس
                            </Dropdown.Item>
                            <Dropdown.Item
                                href="https://snapchat.com/t/yZHKLwzS"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ٢-  الأرتست مريم كاظم
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {/* TikTok Dropdown */}
                    <Dropdown>
                        <Dropdown.Toggle variant="link" id="dropdown-tiktok" className="icon-link">
                            <FontAwesomeIcon icon={faTiktok} size='30px' />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                href="https://www.tiktok.com/@peacesalonkw1?_t=8rMFOVBjfUt&_r=1"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ١- معهد و صالون بيس
                            </Dropdown.Item>
                            <Dropdown.Item
                                href="https://www.tiktok.com/@mariam_kazem11?_t=8rMBRaoEM12&_r=1"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ٢-  الأرتست مريم كاظم
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {/* WhatsApp Link */}
                    <a
                        href="https://wa.me/+96555377707"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="icon-link"
                    >
                        <FontAwesomeIcon icon={faWhatsapp} size='30px' />
                    </a>

                    {/* Phone Link */}
                    <a
                        href="tel:+96555377707"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="icon-link"
                    >
                        <FontAwesomeIcon icon={faPhone} size='30px' />
                    </a>

                    {/* Google Map Link */}
                    <a
                        href="https://maps.app.goo.gl/LhJ9H7a5udWMz2dt5?g_st=iwb"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="icon-link"
                    >
                        <FontAwesomeIcon icon={faLocationDot} size='30px' />
                    </a>
                </div>

            </Card>
        </Container >
    );
}

export default BookingForm;